export interface CmsPreviewParams {
  previewToken?: string
}

export const getCmsPreviewParams = (requestUrl: string): CmsPreviewParams => {
  try {
    const url = new URL(requestUrl, window.location.origin)
    const preview = url.searchParams.get('preview')
    const previewToken = url.searchParams.get('previewToken')?.trim()

    if (preview !== 'true' || !previewToken) {
      return {}
    }

    return { previewToken }
  } catch {
    return {}
  }
}
